/** `null` = não chamar setVolume no YouTube da playlist (a locução está no ar). */
export function volumeNaPlaylist(volumePedido: number, locucaoAtiva: boolean): number | null {
  if (locucaoAtiva) return null;
  return volumePedido;
}
